<template>
  <div
    ref="scrollDOM"
    class="py-2 px-4 text-base-content/50 overflow-auto relative mb-[64px]"
    @scroll="onScroll"
  >
    <!-- Your HTML code goes here -->
    <div>
      <h2 class="text-base font-bold mt-2 mb-2.5 text-center">
        {{ $t("game.beginning") }}
      </h2>
      <NodeGalGameEditor :node="store.nodeMap[store.beginningNode]" />
    </div>

    <template v-for="(item, idx) in store.plotList">
      <div v-if="store.nodeMap[item]" :key="item">
        <h2 class="text-base font-bold mt-2 mb-2.5 text-center">
          {{ $t("game.plotPoint") }} {{ idx + 1 }}
        </h2>
        <NodeGalGameEditor :node="store.nodeMap[item]" />
      </div>
    </template>

    <div
      class="fixed bottom-0 left-0 right-0 bg-primary py-5 flex justify-center"
    >
      <button
        class="btn btn-xs rounded mr-3 fon"
        @click="store.addNode({ type: 2 })"
      >
        <i class="iconfont icon-a- text-xs font-light"></i>
        {{ $t("Buttons.contentNode") }}
      </button>

      <button class="btn btn-primary btn-xs rounded" @click="clickAiGenerate">
        <i class="iconfont icon-a- text-xs font-light"></i>
        {{ $t("Buttons.aiGenerateContentNode") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ApiPostGalGameStoryNodeGenerate } from "@/apis/gal-game";
import { useGalGameEditor } from "@/stores/galGameEditor";
import { showLoadingToast } from "vant";
import { onMounted, ref } from "vue";
import i18n from "@/locales";

const store = useGalGameEditor();

const scrollDOM = ref<HTMLDivElement | null>(null);

const onScroll = (e: Event) => {
  const target = e.target as HTMLDivElement;
  store.scrollTopCache = target.scrollTop;
};

onMounted(async () => {
  if (store.scrollTopCache) {
    scrollDOM.value!.scrollTop = store.scrollTopCache;
  }
});

const clickAiGenerate = async () => {
  const toast = showLoadingToast({
    message: i18n.global.t("Message.AIGenerating"),
  });
  try {
    const { item } = await ApiPostGalGameStoryNodeGenerate(store.galGameId);
    store.nodeMap[item.id] = item;
    store.plotList.push(item.id);
  } catch (e) {
    console.log(e);
  }

  toast.close();
};
</script>

<style scoped>
/* Your CSS code goes here */
</style>
